import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navigation from "./components/Navigation/Navigation";
import Azteq from "./pages/ChatInterface/ChatInterface";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import { createThread, sendMessage } from "./services/chatServices";
import "./App.css";
import FooterMenu from "./components/FooterMenu/FooterMenu";

function ChatRedirect() {
  const location = useLocation();
  const initialMessage = location.state?.initialMessage;
  const navigate = useNavigate();
  const isInitialized = React.useRef(false);

  React.useEffect(() => {
    const initThread = async () => {
      if (isInitialized.current) return;
      isInitialized.current = true;

      try {
        // Create the thread first
        console.log("Creating thread...");
        const threadId = await createThread();
        console.log("Thread created:", threadId);

        let firstResponse;
        if (initialMessage) {
          console.log("Sending initial message:", initialMessage);
          firstResponse = await sendMessage(threadId, initialMessage);
          console.log("Got first response:", firstResponse);
        }

        // Navigate to the chat with the real thread ID
        navigate(`/chat/${threadId}`, {
          state: {
            initialMessage,
            firstResponse,
            skipInitialSend: true,
          },
          replace: true,
        });
      } catch (error) {
        console.error("Error initializing chat:", error);
      }
    };

    initThread();
  }, [initialMessage, navigate]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const isChatRoute = location.pathname.startsWith('/chat');

  return (
    <div
      className="App"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Navigation />
      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<ChatRedirect />} />
          <Route path="/chat/:threadId" element={<Azteq />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      {!isChatRoute && <FooterMenu />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
